import '../variables.css';
export { default } from './components/Slider';
